import React from "react";

export default function AtalhosUsageTable() {
  return (
    <div className="ia-placeholder">
      <h3>⚡ AtalhosUsageTable</h3>
      <p>Uso de atalhos será exibido aqui.</p>
    </div>
  );
}
